import { gql } from 'graphql-tag';

export default gql`
  mutation CancelScheduledMessage($notificationId: Int!) {
    cancelScheduledMessage(notification_id: $notificationId) {
      success
      message
    }
  }
`;